import { ApiTypes, StateRecord } from '@mode/shared/contract-common';

export enum EntitledAction {
  Manage = 'manage',
  Query = 'query',
  View = 'view',
}

export interface DatasourceEntitlementResource extends StateRecord, ApiTypes.ModeResource {
  token: string;
  action: EntitledAction;
  accessor_type: string;
  accessor_token: string;
}
